import Container from '../../atoms/container/spinnerContainer';
import Icon from '../../atoms/icons/spinner';
import { useEffect, useReducer } from 'react';

const INTERVAL = 100;
const MAX_PERCENTAGE = 0.9;
const MIN_PERCENTAGE = 0.1;
const STEP = 0.05;

interface State {
  fill: boolean;
  percentage: number;
}

function reducer(state: State) {
  const fill =
    (state.fill && state.percentage < MAX_PERCENTAGE) ||
    (!state.fill && state.percentage <= MIN_PERCENTAGE);

  if (fill) {
    return {
      fill: true,
      percentage: Math.min(state.percentage + STEP, MAX_PERCENTAGE),
    };
  } else {
    return {
      fill: false,
      percentage: Math.max(state.percentage - STEP, MIN_PERCENTAGE),
    };
  }
}

function Spinner({ type }: { type?: string }) {
  const [state, dispatch] = useReducer(reducer, {
    fill: true,
    percentage: MIN_PERCENTAGE,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch();
    }, INTERVAL);

    return () => {
      clearInterval(interval);
    };
  });

  return (
    <Container type={type} id={'spinnerContainer'}>
      <Icon percentage={state.percentage} />
    </Container>
  );
}

export default Spinner;
